import React, { FunctionComponent, useState } from 'react'
import {
  setSelectedPaymentType,
  useAppDispatch,
  useAppRouter,
  useCheckoutToken,
  useConsumerLendingEligibleInAU,
  useCountry,
  useGetBankingSessionLatestQuery,
  useOpenExistingFacility,
  usePBIRejected,
  usePreAssessmentMutation,
  useSelectedPaymentType,
  useShowAffIdvModal,
  useShowIdvModal,
} from '../../../state'
import { useMonitoringWithEnduringEventProperties } from '../../../integrations/monitoring'
import { TrackingEvent } from '../../../model/monitoring'
import { Country, PaymentType } from '@afterpay/types'
import { Route } from '../../../config/router'
import styles from './style.module.css'
import { Button, useModal } from '@afterpaytouch/core'
import { useTranslation } from 'next-i18next'
import { IdentityVerificationModal } from '../../IdentityVerificationModal'
import { IdentityVerificationModalKey } from '../../../model'

interface PaymentTypesContinueButtonProps {
  setPbiOptionSelected: (bool: boolean) => void
}

export const PaymentTypesContinueButton: FunctionComponent<PaymentTypesContinueButtonProps> = ({ setPbiOptionSelected }) => {
  const { t } = useTranslation()
  const selectedPaymentType = useSelectedPaymentType()
  const dispatch = useAppDispatch()
  const router = useAppRouter()
  const hasPBIRejected = usePBIRejected()
  const country = useCountry()
  const isConsumerLendingEligibleInAU = useConsumerLendingEligibleInAU()
  const token = useCheckoutToken()
  const openExistingFacility = useOpenExistingFacility()
  const { logEvent } = useMonitoringWithEnduringEventProperties()
  const [preAssessment] = usePreAssessmentMutation({ fixedCacheKey: 'shared-pre-assessment' })
  const { data: bankingData, isLoading: bankingDataIsLoading } = useGetBankingSessionLatestQuery(undefined, { skip: !isConsumerLendingEligibleInAU })
  const showIDVModal = useShowIdvModal()
  const showAffIdvModal = useShowAffIdvModal()
  const [clicked, setClicked] = useState<boolean>(false)
  const { showModal } = useModal(IdentityVerificationModalKey)

  const disableContinueButton = typeof selectedPaymentType === 'undefined' || clicked || bankingDataIsLoading

  const clickContinue = async (): Promise<void> => {
    setClicked(true)
    const skipMarketingPage = bankingData?.hasAccounts === true || bankingData?.hasFinances === true
    logEvent(TrackingEvent.PRESSED_CL_ENTRY_PAGE_CONTINUE_BUTTON)

    if (selectedPaymentType === PaymentType.PBI) {
      if (showAffIdvModal) {
        showModal()
      } else {
        setPbiOptionSelected(true)
      }
      return
    }

    if (showIDVModal) {
      showModal()
    } else {
      if (country === Country.AU && !openExistingFacility) {
        try {
          await preAssessment({ token }).unwrap()
          if (skipMarketingPage) {
            router.push(Route.INITIATE_BANK_VERIFICATION)
          } else {
            router.push(Route.PAY_MONTHLY)
          }
        } catch (e) {
          setClicked(false)
          if (!hasPBIRejected) {
            dispatch(setSelectedPaymentType(PaymentType.PBI))
            setPbiOptionSelected(true)
          } else {
            router.push(Route.TERMINAL_ERROR)
          }
        }
      } else {
        router.push(Route.PAYMENT_OPTIONS)
      }
    }
  }

  return (
    <>
      <div className={styles.continueButton}>
        <Button padding='Fluid' loading={clicked} disabled={disableContinueButton} onClick={clickContinue} testNameSpace='payment-types'>
          {t('consumerLending:paymentOptions:continue')}
        </Button>
      </div>
      <IdentityVerificationModal setClicked={setClicked} setPbiOptionSelected={setPbiOptionSelected} />
    </>
  )
}
